"use strict";

import { http } from '../../core';
import config from '../../app.config'

const RequestbaseURL = http.create({baseURL:config.BASEURL})

const RequestUserURL = http.create({ baseURL: config.filterUser })
export default {
    getdictionary(){
        return RequestbaseURL.get("appcenter/apptree/v1/data/dictionary")
    },
    // 全部应用列表
    appList(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/app/list', params);
    },
    //获取全部应用列表（有关键字搜索功能）
    getAppList:function(params){
        return RequestbaseURL.get('appcenter/apptree/v1/app/search/list',params)
    },
    serverList(params) {
        return RequestbaseURL.get('appcenter/apptree/server/v1/list', params)
    },

    addServer(params) {
        return RequestbaseURL.post('appcenter/apptree/server/v1/add', params)
    },

    envList() {
        return RequestbaseURL.get('appcenter/apptree/server/v1/env/list')
    },

    treeLevel1() {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1/tree')
    },

    treeChildren(params) {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1/children', params)
    },

    nodeInfo(params) {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1', params)
    },

    addNode(params) {
        return RequestbaseURL.post('appcenter/apptree/appnode/v1/add', params)
    },

    updateMenu(params) {
        return RequestbaseURL.post('appcenter/apptree/app_folder/v1/update', params)
    },

    updateNode(params) {
        return RequestbaseURL.post('appcenter/apptree/appnode/v1/update', params)
    },

    // 删除应用目录
    deleteMenu(params) {
        return RequestbaseURL.get('appcenter/apptree/app_folder/v1/delete', { app_id: params })
    },

    filterServer(params) {
        return RequestbaseURL.post('appcenter/apptree/server/v1/server_list', { condition: params })
    },

    appTypeAll() {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1/apptype/list')
    },

    filterUser(params) {
        return RequestUserURL.post('wechat/v1/user_list', { name: params })
    },

    folderAdd(params) {
        return RequestbaseURL.post('appcenter/apptree/app_folder/v1/add', params)
    },

    // 主机解绑
    serverNtying(params) {
        return RequestbaseURL.post('appcenter/apptree/app/server/ntying', params)
    },

    upload(params) { // 上传文件
        return RequestbaseURL.post('fastdfs/v1/upload', params, null, true);
    },

    // 获取默认图片
    imgList(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/default/img/list', params);
    },

    // 搜索应用
    appSearch(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/app/search', { name: params });
    },

    // git地址模糊查询
    gitSearch(params) {
        return RequestbaseURL.get('appcenter/apptree/v1/git/search', { git: params });
    },


    // 部署单详细
    deployDescribe(params) {
        return RequestbaseURL.get('ci/api/deploy/describe', params)
    },

    // 部署单日志
    deployLog(params) {
        return RequestbaseURL.get('ci/api/deploy/log', params)
    },

    // 部署单列表
    deployList(params) {
        params = {
            ...params,
            user_name: localStorage.getItem('internalUserid')
        }
        return RequestbaseURL.get('ci/api/deploy', params)
    },

    // 部署单列表
    deployListAll(params) {
        return RequestbaseURL.get('ci/api/deploy', params)
    },

    // 部署单模糊数据
    deploySearch(params) {
        return RequestbaseURL.get('ci/api/deploy/search', params)
    },

    // 执行部署单
    deployRun(params) {
        return RequestbaseURL.post('ci/api/deploy/run', params)
    },


    // 创建部署单模糊数据
    createSearch(params) {
        return RequestbaseURL.get('ci/api/deploy/create/search', params)
    },

    // 创建部署单
    deployCreate(params) {
        return RequestbaseURL.post('ci/api/deploy/create', params)
    },

    // 创建工单查询分支和tag信息
    gitlabSearch(params) {
        return RequestbaseURL.get('ci/api/deploy/gitlab/search', params)
    },

    // 回滚获取rtag列表
    rollbackRtag(params) {
        return RequestbaseURL.get('ci/api/rollback/rtag', params)
    },

    // 审核数据列表
    apiApproval(params) {
        return RequestbaseURL.get('ci/api/approval', params)
    },

    // 审核接口
    approvalStauts(params) {
        return RequestbaseURL.post('ci/api/approval/stauts', params)
    },

    // 中止deploy
    deployKill(params) {
        return RequestbaseURL.post('ci/api/deploy/kill', params)
    },

    // 回滚接口，回滚数据
    deployRollback(params) {
        return RequestbaseURL.post('ci/api/deploy/rollback', params)
    },

    // 获取部署临时信息-列表
    buildHistory(params) {
        return RequestbaseURL.post('appcenter/apptree/cicd/get_app_build_history', params)
    },

    // 根据关键字搜索部署历史信息-列表
    searchBuildHistory(params) {
        return RequestbaseURL.post('appcenter/apptree/cicd/search_app_build_history', params)
    },

    // 获取部署历史信息，用于生产趋势图等
    HistoryMessage(params) {
        return RequestbaseURL.post('appcenter/apptree/cicd/get_grap_app_build_history', params)
    },

    // 获取最新的一个deploy信息
    getLastDeploInfo(params) {
        return RequestbaseURL.post('appcenter/apptree/cicd/get_last_deploy_info', params)
    },

    // 获取单个deploy的详细信息
    getSingleDeployDetailedInfo(params) {
        return RequestbaseURL.post('appcenter/apptree/cicd/get_single_deploy_detailed_info', params)
    },

    // 查询应用和env对应可用服务器组和ip信息
    hostsSearch(params) {
        return RequestbaseURL.get('ci/api/deploy/hosts/search', params)
    },

    // 获取app未使用参数
    unusedParams(params) {
        return RequestbaseURL.get('appcenter/apptree/appnode/v1/unused_params', params)
    },

}
